import { login, logout, getInfo, register } from '@/api/login'
import { getToken, setToken, removeToken } from '@/utils/auth'
import router from '@/router'
const state = {
  token: getToken(),
  current_user: {}
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_CURRENT_USER: (state, user) => {
    state.current_user = user
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles
  }
}

const actions = {
  login ({commit}, userInfo) {
    const { username, password } = userInfo
    return new Promise((resolve, reject) => {
      login({ username: username.trim(), password: password }).then(response => {
        const { token } = response
        commit('SET_TOKEN', token)
        setToken(token)
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },
  getInfo ({ commit, state }) {
    return new Promise((resolve, reject) => {
      if (state.current_user.id) {
        resolve(state.current_user)
      } else {
        getInfo(state.token).then(response => {
          const { data } = response
          if (data.tel) {
            data['name'] = data.name
            const { name } = data
            commit('SET_NAME', name)
            commit('SET_CURRENT_USER', data)
            resolve(data)
          } else {
            // 没有手机号码，返回状态码跳转到绑定页面
            localStorage.setItem('wxMsg', JSON.stringify(data))
            // resolve({'code': 123})
            router.push({ path: '/Bindtel' })
          }
          // data['roles'] = [data.MAccountRole]
          // if (!roles || roles.length <= 0) {
          // reject('getInfo: roles must be a non-null array!')
          // }
          // commit('SET_ROLES', roles)
        }).catch(error => {
          reject(error)
          commit('SET_TOKEN', '')
          commit('SET_CURRENT_USER', {})
          localStorage.removeItem('wxMsg')
          removeToken()
        })
      }
    })
  },
  logout ({ commit, state }) {
    return new Promise((resolve, reject) => {
      logout(state.token).then(() => {
        commit('SET_TOKEN', '')
        commit('SET_CURRENT_USER', {})
        localStorage.removeItem('wxMsg')
        removeToken()
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },
  register ({ commit }, data) {
    return new Promise((resolve, reject) => {
      register(data).then(res => {
        if (res.code === '20000' || res.code === 20000) {
          // const { token } = res
          // commit('SET_TOKEN', token)
          // setToken(token)
          resolve()
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  saveInformation ({ commit }, data) {
    // commit('SET_TOKEN', token)
    setToken(data.token)
    commit('SET_CURRENT_USER', data.user)
    // commit('SET_CURRENT_USER', data)
  },
  getWechat ({ commit }, dataToken) {
    commit('SET_TOKEN', dataToken)
    setToken(dataToken)
    getInfo()
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js